import React from 'react';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import moment from 'moment';

import ModalCustomerPost from '../modal/modalCustomerPost';
import InputUpdate from '../input/inputUpdate';
import ModalTaskPost from '../modal/modalTaskPost';
import ModalAppointmentPost from '../modal/modalAppointmentPost';
import ModalReminderPost from '../modal/modalReminderPost';
import ModalNotePost from '../modal/modalNotePost';
import { appendGraphQlPlanning } from 'src/utils/utilPlanning';
import MyPlanning from '../../appPlanning/myPlanning';
import SubNavBar from '../SubNavBar';
import ModalConfirm from '../modal/modalConfirm';
import Select from 'react-select';
import withAuth from 'src/hoc/withAuth';

const apiTask = '/api/task/';
const apiAppointment = '/api/appointment/';
const apiReminder = '/api/reminder/';
const apiNote = '/api/note/';

const apiContactShow = '/api/contact/show/';
const linkToCustomer = '/dashboard/customer/';
const linkToUser = '/dashboard/user/';

class DisplayContact extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fatalError: undefined,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalPostCustomerOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      isModalDisabledOpen: false,
      jobs: [],
      toAssociate: {
        type: 'contact',
      },
      entity: undefined,
      contactId: undefined,
      deleted: false,
      contactName: '____',
      contactLastName: '____',
      contactPhone: '____',
      contactEmail: '____',
      contactJob: '____',
      contactCompanyName: '____',
      contactOrigin: '____',
      customerAssociated: undefined,
      otherCustomersAssociated: undefined,
      extendedOtherCustomers: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.postResult = this.postResult.bind(this);
    this.updateField = this.updateField.bind(this);
    this.toggleOtherCustomersAssociated = this.toggleOtherCustomersAssociated.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiContactShow;
      let graphQL =
        '{ contact(id:' +
        paramsID +
        '){ id, name, lastname, phoneNumber, email, job, companyName, deleted, origin{ id, labelOrigin }, ' +
        'creator{ user{ id, username } }, ' +
        'customer{ id, installationSite{ socialReason }}, ' +
        'otherCustomersAssociated{ id, installationSite{ socialReason }, dateCreate, creator{ user{ id, username }} } ' +
        appendGraphQlPlanning() +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['contact']) {
            let toAssociate = this.state.toAssociate;
            toAssociate['id'] = data['data']['contact']['id'];
            toAssociate['name'] = data['data']['contact']['name'] + ' ' + data['data']['contact']['lastname'];
            let checkedJob = data['data']['contact']['job'] ? data['data']['contact']['job'] : '';
            let checkedCompanyName = data['data']['contact']['companyName']
              ? data['data']['contact']['companyName']
              : '';
            this.setState({
              entity: data['data']['contact'],
              toAssociate: toAssociate,
              contactId: data['data']['contact']['id'],
              contactName: data['data']['contact']['name'],
              deleted: data['data']['contact']['deleted'],
              contactLastName: data['data']['contact']['lastname'].toUpperCase(),
              contactPhone: data['data']['contact']['phoneNumber'],
              contactEmail: data['data']['contact']['email'],
              contactJob: checkedJob,
              contactCompanyName: checkedCompanyName,
              contactOrigin: data['data']['contact']['origin']['labelOrigin'],
              contactCreator: data['data']['contact']['creator'],
              customerAssociated: data['data']['contact']['customer'],
              dataTask: data['data']['contact']['tasks'],
              dataAppointment: data['data']['contact']['appointments'],
              dataReminder: data['data']['contact']['reminders'],
              dataNote: data['data']['contact']['notes'],
              otherCustomersAssociated: data['data']['contact']['otherCustomersAssociated'],
            });
          } else {
            let message = 'Erreur lors de la récupération du contact.';

            if (data['errors'] && data['errors'].length > 0) {
              message = data['errors'].map((e) => e.message).join(', ');
            }

            throw new Error(message);
          }
        })
        .catch((error) => {
          this.setState({ fatalError: error.message });
        });

      this.getJobs();
    }
  }

  getJobs = () => {
    this.props
      .authFetch('/api/jobs/', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        const hasJob = !!data.find((job) => job.name === this.state.contactJob);

        this.setState({
          jobs: hasJob ? data : [...data, { id: 0, name: this.state.contactJob }],
        });
      });
  };

  deleteCollaborative = (id, type) => {
    let json = { [type]: { id } };

    let collaborative = {
      type: undefined,
      message: undefined,
      apiUrl: undefined,
    };

    let afterView = 1;
    switch (type) {
      case 'task':
        collaborative.type = 'task';
        collaborative.message = 'tâche';
        collaborative.apiUrl = apiTask;
        afterView = 1;
        break;
      case 'appointment':
        collaborative.type = 'appointment';
        collaborative.message = 'rendez-vous';
        collaborative.apiUrl = apiAppointment;
        afterView = 2;
        break;
      case 'reminder':
        collaborative.type = 'reminder';
        collaborative.message = 'rappel';
        collaborative.apiUrl = apiReminder;
        afterView = 3;
        break;
      case 'note':
        collaborative.type = 'note';
        collaborative.message = 'note';
        collaborative.apiUrl = apiNote;
        afterView = 4;
        break;
    }

    let queryURL = collaborative.apiUrl;
    let tabParam = encodeURIComponent(JSON.stringify(json));
    queryURL += tabParam;

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.isValid) {
          this.componentDidMount();
          this.setState({ selectedView: afterView });
          this.props.openToast(true, 'Suppression réalisée ');
        } else {
          this.props.openToast(false, 'Erreur suppression. Veuillez réessayer');
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.openToast(false, 'Impossible à supprimer');
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    let triggerContact = {
      id: this.state.contactId,
      name: this.state.contactName + ' ' + this.state.contactLastName,
    };
    const { otherCustomersAssociated } = this.state;
    let noOtherCustomersAssociated =
      this.state.otherCustomersAssociated != undefined && this.state.otherCustomersAssociated.length == 0 ? (
        <span>Aucun autre compte associé à ce contact.</span>
      ) : (
        ''
      );

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Fiche Contact'
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={() => this.openModal('customer')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Client</span>
            </button>
            <button onClick={() => this.openModal('task')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Tâche</span>
            </button>
            <button
              onClick={() => this.openModal('appointment')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-plus'>Rdv</span>
            </button>
            <button onClick={() => this.openModal('reminder')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Rappel</span>
            </button>
            <button onClick={() => this.openModal('note')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Note</span>
            </button>
            {!this.state.deleted ? (
              <button
                onClick={() => this.openModal('disabled')}
                type='button'
                className='btn btn-sm btn-outline-success'
              >
                <span className='icon icon-trash'>Désactiver</span>
              </button>
            ) : (
              <button onClick={this.enabledContact} type='button' className='btn btn-sm btn-outline-success'>
                <span className='icon icon-power-plug'>Réactiver</span>
              </button>
            )}
          </div>
        </SubNavBar>

        {!this.state.fatalError ? (
          <div id='appViewContent'>
            <div className='entity-display'>
              <form>
                {this.state.deleted && (
                  <div className='alert alert-danger' role='alert'>
                    Ce contact a été désactivé
                  </div>
                )}

                <InputUpdate
                  inputType={'text'}
                  inputLabel={'Nom'}
                  inputValue={this.state.contactLastName}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'lastname')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
                <InputUpdate
                  inputType={'text'}
                  inputLabel={'Prénom'}
                  inputValue={this.state.contactName}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'name')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
                <InputUpdate
                  inputType={'text'}
                  inputLabel={'Téléphone'}
                  inputValue={this.state.contactPhone}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'phoneNumber')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
                <InputUpdate
                  inputType={'text'}
                  inputLabel={'Email'}
                  inputValue={this.state.contactEmail}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'email')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
                <div className='form-group'>
                  {this.state.contactId && this.state.jobs && (
                    <InputUpdate
                      inputLabel="Rôle/métier dans l'entreprise"
                      inputValue={this.state.contactJob}
                      renderInput={(props) => (
                        <Select
                          {...props}
                          className='w-100'
                          labelKey='name'
                          valueKey='name'
                          options={this.state.jobs}
                          clearable={false}
                          fullWidth
                        />
                      )}
                      submitUpdate={(inputValue) => this.updateField(inputValue.name, 'text', 'job')}
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                  )}
                </div>
                <InputUpdate
                  inputType={'text'}
                  inputLabel={"Nom d'entreprise"}
                  inputValue={this.state.contactCompanyName}
                  submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'companyName')}
                  toggleBlackOut={() => this.props.toggleBlackOut()}
                />
                <div className='form-group'>
                  <label>Origine</label>
                  <input
                    name='contactOrigin'
                    value={this.state.contactOrigin}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    readOnly
                  />
                </div>
                {this.state.contactCreator && (
                  <div className='form-group'>
                    <label>Créateur</label>
                    <Link to={linkToUser + this.state.contactCreator.user.id}>
                      <input
                        name='creator'
                        value={this.state.contactCreator.user.username}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        readOnly
                      />
                    </Link>
                  </div>
                )}
                {this.state.customerAssociated && (
                  <div className='form-group'>
                    <label>Client associé</label>
                    <Link to={linkToCustomer + this.state.customerAssociated.id}>
                      <input
                        name='customerAssociated'
                        value={this.state.customerAssociated.installationSite.socialReason}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        readOnly
                      />
                    </Link>
                  </div>
                )}
              </form>
            </div>
            <div className='alignHorizontal'>
              <h3>
                Autres clients associés (
                {this.state.otherCustomersAssociated ? this.state.otherCustomersAssociated.length : '_'})
              </h3>
              <button
                onClick={this.toggleOtherCustomersAssociated}
                type='button'
                className='btn btn-sm btn-outline-success'
              >
                <span
                  className={
                    'icon ' + (this.state.extendedOtherCustomers ? 'icon-chevron-thin-up ' : 'icon-chevron-thin-down ')
                  }
                />
              </button>
            </div>
            {this.state.extendedOtherCustomers &&
              (otherCustomersAssociated ? (
                otherCustomersAssociated
                  .sort((a, b) => new Date(b.dateCreate) - new Date(a.dateCreate))
                  .map((data) => (
                    <li className={'list-group-item entity-row '} key={data.id}>
                      <Link to={linkToCustomer + data.id}>
                        <span>{data.installationSite.socialReason}</span>
                      </Link>
                      <span>{moment(data.dateCreate).format('DD-MM-YY')}</span>
                      {data.creator ? (
                        <Link to={linkToUser + data.creator.user.id}>
                          <span>{data.creator.user.username}</span>
                        </Link>
                      ) : (
                        <span>{'Non-renseigné'}</span>
                      )}
                    </li>
                  ))
              ) : (
                <li className='list-group-item'>Chargement...</li>
              ))}
            {this.state.extendedOtherCustomers && noOtherCustomersAssociated}

            <MyPlanning
              onEntity={true}
              dataTask={this.state.dataTask}
              dataAppointment={this.state.dataAppointment}
              dataReminder={this.state.dataReminder}
              dataNote={this.state.dataNote}
              deleteCollaborative={this.deleteCollaborative}
            />
          </div>
        ) : (
          <div className='alert alert-danger' role='alert'>
            {this.state.fatalError}
          </div>
        )}

        <ModalCustomerPost
          myContact={triggerContact}
          className='myModal'
          openToast={this.props.openToast}
          isOpen={this.state.isModalPostCustomerOpen}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalTaskPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostTaskOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalAppointmentPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostAppointmentOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalReminderPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostReminderOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalNotePost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostNoteOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalConfirm
          className='myModal'
          modalText={{
            title: 'Attention',
            message: `Êtes-vous sur de vouloir désactiver ce contact ?\nIl n'apparaitra plus dans les résultats de recherche.`,
          }}
          isOpen={this.state.isModalDisabledOpen}
          onSubmit={this.disabledContact}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />
      </div>
    );
  }

  disabledContact = () => {
    this.updateField(1, 'bool', 'deleted');
  };

  enabledContact = () => {
    this.updateField(0, 'bool', 'deleted');
  };

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalPostCustomerOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalDisabledOpen: false,
      isModalPostNoteOpen: false,
    });
  }

  openModal(type) {
    let toOpen = undefined;
    switch (type) {
      case 'customer':
        toOpen = 'isModalPostCustomerOpen';
        break;
      case 'task':
        toOpen = 'isModalPostTaskOpen';
        break;
      case 'appointment':
        toOpen = 'isModalPostAppointmentOpen';
        break;
      case 'reminder':
        toOpen = 'isModalPostReminderOpen';
        break;
      case 'note':
        toOpen = 'isModalPostNoteOpen';
        break;
      case 'disabled':
        toOpen = 'isModalDisabledOpen';
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  postResult(type, promise) {
    let messageLabel = 'entité';
    switch (type) {
      case 'customer':
        messageLabel = 'client';
        break;
      case 'task':
        messageLabel = 'tâche';
        break;
      case 'appointment':
        messageLabel = 'rdv';
        break;
      case 'reminder':
        messageLabel = 'rappel';
        break;
      case 'note':
        messageLabel = 'note';
        break;
    }
    promise.then((result) => {
      if (result.wentFine) {
        this.props.openToast(true, 'Succès création ' + messageLabel);
        this.componentDidMount();
      } else {
        this.props.openToast(false, 'Erreur création ' + messageLabel + '. Veuillez réessayer');
      }
    });
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { contact(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiContactShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['contact'][fieldName] == newValue) {
          if (fieldName in this.state) {
            this.setState({ [fieldName]: data['data']['contact'][fieldName] });
          }
          this.props.openToast(true, 'Votre modification a bien été prise en compte.');
        } else {
          this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
        }
      })
      .catch((error) => {
        console.log('erreur fetch UPDATE contact entity');
      });
  }

  toggleOtherCustomersAssociated() {
    this.setState({
      extendedOtherCustomers: !this.state.extendedOtherCustomers,
    });
  }
}

export default withAuth(DisplayContact);
